var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Status', {
    staticClass: "s-text-secondary s-mb-6",
    attrs: {
      "icon": "check",
      "message": "密碼修改完成！"
    }
  }), _c('p', {
    staticClass: "s-mb-6 s-text-center"
  }, [_vm._v("請重新登入會員")]), _c('router-link', {
    staticClass: "s-btn s-btn-secondary",
    attrs: {
      "to": {
        name: 'LiffGroupBuyingAuthLogin',
        query: _vm.$route.query
      }
    }
  }, [_vm._v(" 重新登入 ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }